import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";

export async function renderFormFieldWidget(context, widget, parent, override = null) {

    const device = widget?.properties?.desktop;
    if (!device) return;

    // <div class="widget form_field_widget">
    const container = context.document.createElement("div");
    container.classList.add("widget", "form_field_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    applyFieldStyles(styles, device);

    container.setAttribute("style", cssUtil.toStyleString(styles));
    container.setAttribute("data-widgetId", widget.uid);
    container.setAttribute("data-widgetType", widget.type);
    container.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(container);

    // Label
    const labelEl = renderLabel(context, device);
    if (labelEl) {
        container.appendChild(labelEl);
    }

    // Input (div-based)
    const inputEl = renderInput(context, device);
    container.appendChild(inputEl);

    return container;
}

function renderLabel(context, device) {
    const label = device.label;
    if (!label) return null;

    const el = context.document.createElement("div");
    el.innerHTML = label;

    const styles = {};
    applyLabelStyles(styles, device);

    el.setAttribute("style", cssUtil.toStyleString(styles));
    return el;
}

function renderInput(context, device) {
    const el = context.document.createElement("div");
    el.classList.add("input");

    if (device.placeholder) {
        el.innerHTML = device.placeholder;
    }

    const styles = {};
    applyInputStyles(styles, device);

    el.setAttribute("style", cssUtil.toStyleString(styles));
    return el;
}

function applyFieldStyles(styles, device) {
    const alignment = device.styles?.layout?.alignment;
    if (alignment) {
        styles["text-align"] = alignment;
    }
}

function applyLabelStyles(styles, device) {
    const layout = device.styles?.layout || {};
    const alignment = layout.alignment;
    const fieldSpacing = layout.fieldSpacing;
    const labelPadding = layout.labelPadding;

    if (fieldSpacing) {
        styles["padding-bottom"] = `${fieldSpacing}px`;
    }

    if (labelPadding) {
        if (alignment === "left") {
            styles["padding-left"] = `${labelPadding}px`;
        } else if (alignment === "right") {
            styles["padding-right"] = `${labelPadding}px`;
        }
    }

    const regular = device.styles?.regular;
    if (!regular?.label) return;

    applyColor(styles, "color", regular.label.color);
    applyFont(styles, regular.label);
}

function applyInputStyles(styles, device) {
    const layout = device.styles?.layout || {};
    const alignment = layout.alignment;
    const inputPadding = layout.inputPadding;

    if (inputPadding) {
        if (alignment === "left") {
            styles["padding-left"] = `${inputPadding}px`;
        } else if (alignment === "right") {
            styles["padding-right"] = `${inputPadding}px`;
        }
    }

    const regular = device.styles?.regular;
    if (!regular?.input) return;

    applyColor(styles, "background", regular.input.background);
    applyColor(styles, "color", regular.input.placeholderColor);

    applyFont(styles, regular.input);
    applyInputBorder(styles, regular.border);
}

function applyColor(styles, cssProp, colorProp) {
    if (!colorProp) return;

    if (colorProp.type === "gradient") {
        styles[cssProp] = cssUtil.getCssGradient(colorProp);
    } else if (colorProp.type === "solid") {
        styles[cssProp] = cssUtil.getCssColor(colorProp);
    }
}

function applyFont(styles, fontStyle) {
    const font = fontStyle?.font;
    if (!font) return;

    if (font.fontFamily) styles["font-family"] = font.fontFamily;
    if (font.fontSize) styles["font-size"] = `${font.fontSize}px`;
    if (font.lineSpacing) styles["line-height"] = `${font.lineSpacing}em`;
    if (font.letterSpacing) styles["letter-spacing"] = `${font.letterSpacing}em`;
}

function applyInputBorder(styles, border) {
    if (!border) return;

    const r = border.radius;
    if (r) {
        if (r.topLeft) styles["border-top-left-radius"] = `${r.topLeft}px`;
        if (r.topRight) styles["border-top-right-radius"] = `${r.topRight}px`;
        if (r.bottomRight) styles["border-bottom-right-radius"] = `${r.bottomRight}px`;
        if (r.bottomLeft) styles["border-bottom-left-radius"] = `${r.bottomLeft}px`;
    }

    applyColor(styles, "border-color", border.color);

    const width = parseInt(border.width || 0, 10);
    let borderWidth = width;

    if (border.style === "all") {
        styles["border-width"] = `${width}px`;
        borderWidth = width * 2;
    } else {
        styles["border-bottom-width"] = `${width}px`;
    }

    const lineHeight = 37 - borderWidth;
    styles["line-height"] = `${lineHeight}px`;
}